// Contact Form 7 guard — blocks a second submission while one is in flight and
// drops stale validation tips, so error messages can't stack up on re-submit.

const BUSY = 'kd-cf7-busy';
const DONE_EVENTS = ['wpcf7submit', 'wpcf7invalid', 'wpcf7spam', 'wpcf7mailsent', 'wpcf7mailfailed'];
const FAILSAFE_MS = 20000;

function clearTips(form) {
  form.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => tip.remove());
  form.querySelectorAll('.wpcf7-not-valid').forEach((el) => el.classList.remove('wpcf7-not-valid'));
}

function setBusy(form, busy) {
  form.classList.toggle(BUSY, busy);
  form.querySelectorAll('.wpcf7-submit').forEach((btn) => {
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  });
}

function guard(form) {
  if (form.dataset.kdCf7Guard) return;
  form.dataset.kdCf7Guard = '1';

  let timer = null;
  const release = () => {
    clearTimeout(timer);
    setBusy(form, false);
  };

  form.addEventListener(
    'submit',
    (event) => {
      if (form.classList.contains(BUSY)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      clearTips(form);
      setBusy(form, true);
      // CF7 always fires a wpcf7submit event, but never strand the button if it doesn't.
      timer = setTimeout(release, FAILSAFE_MS);
    },
    true
  );

  DONE_EVENTS.forEach((name) => form.addEventListener(name, release));
}

export default function initContactForms() {
  document.querySelectorAll('form.wpcf7-form').forEach(guard);
}
